import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { queryClient } from "..";
import { locationApi } from "../api/location-api";
import {
  setLocationPageAction,
  setLocationPageByDtoAction,
} from "../app/reducers/location-slice";
import { store } from "../app/store";
import { Confirm } from "../types/confirm";
import {
  CreateLocationPayload,
  SearchLocationPagePayload,
  UpdateLocationPayload,
} from "../types/location/location-payload";

export enum LocationQueryKey {
  Create = "CreateLocation",
  Update = "UpdateLocation",
  GetById = "GetLocationById",
  Page = "LocationPage",
  UploadImages = "UploadLocationImages",
}

export const useCreateLocationMutation = () => {
  return useMutation(
    LocationQueryKey.Create,
    (payload: CreateLocationPayload) => locationApi.create(payload),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(LocationQueryKey.GetById);
        toast.success(Confirm.Confirm);
      },
    }
  );
};

export const useUpdateLocationMutation = () => {
  return useMutation(
    LocationQueryKey.Update,
    (params: { id: string; payload: UpdateLocationPayload }) => {
      return locationApi.update(params.id, params.payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(LocationQueryKey.GetById);
        toast.success(Confirm.Update);
      },
    }
  );
};

export const useGetLocationByIdQuery = (payload: string) => {
  return useQuery(
    [LocationQueryKey.GetById, payload],
    () => locationApi.getById(payload),
    {
      enabled: !!payload,
      onSuccess: ({ data }) => {
        const locationDto = data;
        store.dispatch(
          setLocationPageByDtoAction({
            locationDto,
          })
        );
      },
    }
  );
};

export const useGetLocationPageQuery = (payload: SearchLocationPagePayload) => {
  return useQuery(
    [LocationQueryKey.Page, payload],
    () => locationApi.search(payload),
    {
      enabled: payload.hasOwnProperty("page"),
      onSuccess: ({ data }) => {
        const locationPageDto = data;
        store.dispatch(
          setLocationPageAction({
            locationPageDto,
          })
        );
      },
    }
  );
};

export const useUploadLocationImagesMutation = () => {
  return useMutation(
    LocationQueryKey.UploadImages,
    (payload: FormData) => {
      return locationApi.uploadImages(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(LocationQueryKey.GetById);
      },
    }
  );
};
